import user from "./user";
import device from './device'

export default {
  user,
  device
};

